import React from "react";

import { Button } from "src/app/components/Button/Button";
import Attachment from "src/app/Task/Attachments/Attachment";
import { AttachmentPlacement, TaskType, PublishedContent } from "src/types";
import { ReactComponent as RemoveIcon } from "src/images/trash-can-gray.svg";
import { ReactComponent as DownloadIcon } from "src/images/download-rounded.svg";

interface Props {
  data: PublishedContent;
  onClickRemoveContent?: () => void;
}

export default function PublishedContentListItem({
  data,
  onClickRemoveContent,
}: Props) {
  return (
    <li className="published-content__list-item">
      <div className="published-content__filename-wrapper">
        <Attachment
          data={data}
          place={AttachmentPlacement.PublishedContent}
          taskType={TaskType.Publication}
        />

        <div className="published-content__filename">{data.name}</div>
      </div>
      <div className="published-content__buttons">
        {!data.isUrlFile && (
          <a
            download
            href={data.downloadUrl}
            className="ws-button ws-button--white ws-button--small ws-button--text-with-icon"
          >
            <DownloadIcon />
          </a>
        )}
        {onClickRemoveContent && (
          <Button
            variant="white"
            size="small"
            textWithIcon
            onClick={onClickRemoveContent}
          >
            <RemoveIcon />
          </Button>
        )}
      </div>
    </li>
  );
}
